export default __webpack_public_path__ + "static/media/one.18f727aa.jpg";